// extracted by mini-css-extract-plugin
module.exports = {"root":"Success_root__3PaHP","success-alert":"Success_success-alert__34fmp","success-message":"Success_success-message__DR9GR","success-title":"Success_success-title__2-Bav"};